<template>

  <div class="actGift" :style="info.css" @click.prevent="get_gift">
    <img :src="image" class="img">
    <div v-if="loading" class="loading">
      <div class="fall"></div>
      <van-loading type="spinner" color="white"/>
    </div>
  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import {getJSON, postJSON} from '../../api/myaxios'
  import {Loading} from 'vant';
  import Vue from 'vue';
  import {onUseInfoLoad} from '../../tools/onUseInfoLoad'
  import process_award from './Lottery/process_award'

  Vue.use(Loading);


  export default {
    name: 'ActGift',
    props: ['info'],
    components: {Loading},
    data() {
      return {
        loading: false,
        stock: 1, //奖品库存，设置为1是为了获取状态前是可领取状态
        has: 0, //是否已经领取过了
        remain_times: 1 // 剩余抽奖领取次数，这个组件中只能领取一次
      }
    },
    methods: {
      get_gift() {
        if (this.loading) {
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false
        }, 333);
        click_handler(this.info.name, () => {
          if(this.stock <= 0){
            return;
          }
          if (this.has) {
            //已领取，不能领取第二次，展示我的奖品弹窗。
            window.$lottery_history_dialog.show();
            return;
          }else if(this.remain_times <= 0){
            //无机会；
            this.handleNoTimes();
            return;
          }else{
            this._get_gift();
          }
        }, {
          need_login: true,
          need_act: true,
          need_new_user: false,
          need_vip_level: -1,
        })
      },
      _get_gift() {
        if (!window.$bus.user.ticket) {
          return;
        }
        const param = {
          ticket: window.$bus.user.ticket,
          act_name: window.rootdata.act_name,
          item_id: this.info.item_id
        };

        getJSON(`//vipact3.api.mgtv.com/api/v1/act/lot/recv/one`, param)
          .then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              process_award(res.data);
              this.remain_times = 0;
              this.has = 1;
            }
          })
      },
      queryStatus() {
        this._queryStock();
        onUseInfoLoad(this._queryHasGet,true);
      },
      _queryHasGet() {
        const ticket = window.$bus.user.ticket;
        if (!ticket) {
          return;
        }
        const params = {
          ticket,
          act_name: window.rootdata.act_name,
          item_id: this.info.item_id, //奖品ID
          t: new Date().getTime()
        }
        getJSON(`//vipact3.api.mgtv.com/api/v1/act/lot/recv/has`, params)
          .then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              this.has = res.data.has;
              this.remain_times = res.data.remain_times;
            }
          })
      },
      _queryStock() {
        const params = {
          act_name: window.rootdata.act_name,
          item_id: this.info.item_id, //奖品ID
          t: new Date().getTime()
        };
        getJSON(`//vipact3.api.mgtv.com/api/v1/act/lot/recv/stock`, params)
          .then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              this.stock = res.data.stock;
            }
          })
      },
      handleNoTimes() {
        console.log('handleNoTimes')
        //no_times
        const action_type = this.info.action_type_notimes;
        const action_info = this.info.action_info_notimes;
        if (action_type && action_type!== 'none') {
          let success_cb = null;
          if (action_type === 'showRulerDialog') {
            success_cb = () => { //success cb ,弹窗回调
              const modal_type = this.info.action_type_notimes_modal;
              const modal_info = this.info.action_info_notimes_modal;
              if (modal_type) {
                handler_action({
                  action_info: modal_info,
                  action_type: modal_type
                })
              }
            }
          }
          handler_action({
            action_type,
            action_info
          }, success_cb)
        }else{
          window.$toast('您还不符合领取资格哦')
        }
      },
    },
    computed: {
      image() {
        if (this.has) {
          return this.info.gift_img2; //已领取
        } else {
          if (this.stock <= 0) {
            return this.info.gift_img3; //已领完
          }
        }
        return this.info.gift_img1; //可领取
      },
      ticket() {
        return window.$bus.user.ticket
      }
    }
    ,
    created() {
      this.queryStatus();
    }
    ,
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .actGift
    overflow hidden
    .img
      display block
      width 100%
      height 100%

    .loading
      position absolute
      width 100%
      height 100%
      top 0
      left 0
      display flex
      justify-content center
      align-items center

    .fall
      position absolute
      width 100%
      height 100%
      top 0
      left 0
      background-color: rgba(0, 0, 0, .3);

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActGift.vue